import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { SBox, SIcon } from '@avalara/skylab-sdk/react';
import React from 'react';
import styled from 'styled-components';
const PlanWrapper = styled.div `
  s-box {
    border: 2px ${COLORS.blue} solid;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  }
`;
const IossOfferPlan = () => (React.createElement(PlanWrapper, null,
    React.createElement(SBox, { className: 'margin-bottom-sm margin-top-sm margin-left-lg margin-right-lg' },
        React.createElement("div", { className: 'margin-all-sm margin-top-xs' },
            React.createElement("h2", { className: 'text-center' }, "Avalara's IOSS solution includes:"),
            React.createElement("h3", { className: 'margin-top-sm' },
                React.createElement(SIcon, { name: 'check', className: 'margin-right-sm' }),
                "IOSS registration and identification number"),
            React.createElement("p", { className: 'margin-left-lg' }, "After you register, use your IOSS identification number for all shipments to the EU under \u20AC150"),
            React.createElement("h3", { className: 'margin-top-lg' },
                React.createElement(SIcon, { name: 'check', className: 'margin-right-sm' }),
                "Monthly returns filing"),
            React.createElement("p", { className: 'margin-left-lg' },
                "File returns electronically through the IOSS portal of the EU member state where ",
                "you're",
                " registered"),
            React.createElement("h3", { className: 'margin-top-lg' },
                React.createElement(SIcon, { name: 'check', className: 'margin-right-sm' }),
                "Intermediary services"),
            React.createElement("p", { className: 'margin-left-lg' }, "Avalara acts as your IOSS intermediary to complete registration and comply with EU requirements")))));
export default IossOfferPlan;
